import commonConstant from '../../common/_commonConstant';

export const isSuperAdmin = getProfile => {
  try {
    if (getProfile.userRole.userRoleCode === commonConstant.roleSuperAdmin) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const isAccounting = getProfile => {
  try {
    if (getProfile.userRole.userRoleCode === commonConstant.roleAccounting) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const isCashier = getProfile => {
  try {
    if (getProfile.userRole.userRoleCode === commonConstant.roleCashier) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const isAdmin = getProfile => {
  try {
    if (getProfile.userRole.userRoleCode === commonConstant.roleAdmin) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const isOperation = getProfile => {
  try {
    if (getProfile.userRole.userRoleCode === commonConstant.roleOperation) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const userEmail = getProfile => {
  try {
    return getProfile.user.userEmail;
  } catch (error) {
    return null;
  }
};

export const userRoleName = getProfile => {
  try {
    return `${getProfile.userRole.userRoleName.charAt(0).toUpperCase()}${getProfile.userRole.userRoleName.slice(1)}`;
  } catch (error) {
    return null;
  }
};

export const userName = getProfile => {
  try {
    return `${getProfile.user.userName.charAt(0).toUpperCase()}${getProfile.user.userName.slice(1)}`;
  } catch (error) {
    return null;
  }
};

export const buildingRefNumber = getProfile => {
  try {
    return getProfile.building.buildingRefNo;
  } catch (error) {
    return null;
  }
};

export const buildingName = getProfile => {
  try {
    return getProfile.building.buildingName;
  } catch (error) {
    return null;
  }
};

export const phoneNumber = getProfile => {
  try {
    return getProfile.user.userProfile.mobilePhone;
  } catch (error) {
    return null;
  }
};

export const profileErrorDetail = detail => {
  try {
    switch (detail) {
      case 'current password is incorrect':
        return commonConstant.userProfileCurrentPassword;
      case 'the new password must be over or equal 8 characters.':
        return commonConstant.userProfileNewPassword;
      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};
